import { render, staticRenderFns } from "./CaregiverEdit.vue?vue&type=template&id=44b6b172&scoped=true"
import script from "./CaregiverEdit.vue?vue&type=script&lang=js"
export * from "./CaregiverEdit.vue?vue&type=script&lang=js"
import style0 from "./CaregiverEdit.vue?vue&type=style&index=0&id=44b6b172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b6b172",
  null
  
)

export default component.exports